import {Injectable} from '@angular/core';
import {Observable} from 'rxjs/Observable';

import {Thesis} from 'shared/classes/thesis';
import {ThesisDetailsRepository} from './../repositories/thesis-details.repository';

@Injectable()
export class ThesisDetailsService {

  constructor(private detailsRepository: ThesisDetailsRepository) { }

  public getThesisById(id: string): Observable<Thesis> {
    return this.detailsRepository.getThesisById(id);
  }

  public saveThesis(thesis: Thesis): Observable<Thesis> {
    return this.detailsRepository.saveThesis(thesis);
  }

  public updateThesis(thesis: Thesis): Observable<Thesis> {
    return this.detailsRepository.updateThesis(thesis);
  }
}



// WEBPACK FOOTER //
// /usr/src/app/src/app/modules/thesis/thesis-details/services/thesis-details.service.ts